import { IS_PROD } from "./constants"

const showFlag = !IS_PROD

export const Flags = {
  General: {
    Example: showFlag,
    Theming: false,
    PortfolioPdf: true,
    // Task tracker columns and the All tasks view in project quick views.
    DeveloperTasks: true,
    BuildingOwnerTasks: true,
  },
}

export type FlagsType = typeof Flags
